<template>
  <div class="container top-level-div">
    <div v-if="!contributing">
      <h1 ref="pageTitle">Blog</h1>
      <hr>
      <div class="row">
        <div class="col-md-3">
          <label class="filter-label">Category</label>
          <select class="form-control" v-model="categoryFilter">
            <option>All</option>
            <option v-for="(category, index) in categories" :key="'category'+index">{{ category }}</option>
          </select>
        </div>
        <div class="col-md-9">
          <div style="height: 65px;">
            <!-- <button class="mylisting-button dark-button" @click="contribute()" style="float: right;">Contribute</button> -->
            <router-link v-if="$store.getters.userID" :to="{ name: 'New Blog Post' }" class="mylisting-button dark-button" style="float: right; text-align: center;">Contribute</router-link>
            <router-link v-if="!$store.getters.userID" :to="{ name: 'Login' }" class="mylisting-button dark-button" style="float: right; text-align: center;">Contribute</router-link>
          </div>
          <div>
            <a href="" style="float: right;" @click.prevent="showWhyContributeModal()">Why should I contribue?</a>
          </div>

          <div>
            <!-- <label class="filter-label">Category</label>
            <select class="form-control" v-model="categoryFilter">
              <option>All</option>
              <option v-for="(category, index) in categories" :key="'category'+index">{{ category }}</option>
            </select> -->
          </div>
        </div>

      </div>

      <div class="row">
        <div v-for="blogPost in blogPosts" :key="blogPost.id" class="col-md-6 mt-4">
          <router-link :to="{ name: 'Blog Post', params: { id: blogPost.id } }" target="_blank" style="color: var(--coredarkcolor);">
          <div class="p-4" style="border: 1px solid var(--bootstrapgrey);">
            <img :src="blogPost.hero_image" alt="" width="100%" height="" style="background-size: cover;">
            <!-- https://stackoverflow.com/questions/11757537/css-image-size-how-to-fill-not-stretch -->
            <!-- <div class="heroimage" style="width: 100%; height: 250px; background-size: cover;" :style="{'background-image': url(blogPost.hero_image)}"></div> -->
            <h3 class="mt-3">{{ blogPost.title }}</h3>
            <p>{{ new Date(blogPost.created_date).toDateString() }}</p>
            <hr>
            <!-- <pre v-html="blogPost.content"></pre> -->
          </div>
          </router-link>
        </div>
      </div>

      <modal name="why-contribute-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
        <div class="p-5">
          <h3>Want to author an article?</h3>
          <hr>
          <p>You can publish an article as a one-time guest writer, or more frequently as an official content contributor (content contributors are featured on our <router-link :to="{ name: 'Team' }">website</router-link>!).</p>
          <p class="mt-2">As an author, you will get to:</p>
          <ul>
            <li>Put your name on the radar of various Global Health professionals</li>
            <li>Gain visibility in a global audience </li>
            <li>Build your credibility by adding published content in an area you’re passionate about</li>
            <li>Have your post shared widely through our website, newsletter and social media channels</li>
          </ul>
          <p class="mt-2">Interested? Submit a piece and our team will review it and get back to you, or contact us at info@thrivehire.org.</p>
        </div>
      </modal>

    </div>

    <div v-if="contributing">
      <h1>New Blog Post</h1>
      <hr>
      <app-blog-post-form></app-blog-post-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import BlogPostForm from './BlogPostForm';

  // https://www.npmjs.com/package/vue-loading-overlay
  import Vue from 'vue';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  // Init plugin
  Vue.use(Loading);

  export default {
    data() {
      return {
        blogPosts: [],
        categories: [],
        categoryFilter: 'All',
        contributing: false,
      }
    },
    components: {
      appBlogPostForm: BlogPostForm,
    },
    created() {
      this.categories = this.$store.getters.blogCategories

      this.getBlogs()
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML
    },
    methods: {
      getBlogs() {
        // https://www.npmjs.com/package/vue-loading-overlay
        let loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          // container: this.$refs.formContainer,
          // canCancel: true,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        // simulate AJAX
        setTimeout(() => {
          loader.hide()
        },2000)

        axios.get('/api/blogposts/?published=true&agency='+this.$store.getters.agencyID.toString())
          .then(res => {
            this.blogPosts = res.data
            this.blogPosts = this.blogPosts.sort((a, b) => (a.created_date < b.created_date) ? 1 : -1)
          })
          .catch(error => console.log(error))
      },
      contribute() {
        this.contributing = true
      },
      showWhyContributeModal() {
        this.$modal.show('why-contribute-modal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/blog/Blog.vue